<template>
  <div class="register">
    <!-- <div class="top-title">
      {{isPerfect==='1'?'完善信息':'注册'}}
    </div> -->
    <div class="content">
      <van-field
        label="供应商名称"
        ref="supplierName"
        required
        maxlength="128"
        center
        autocomplete="off"
        placeholder="请输入"
        v-model.trim="supplierAccountInfo.supplierName"
        @click="domfocus($event,'supplierName')"
      />
      <van-field
        label="注册手机"
        ref="mobile"
        required
        center
        autocomplete="off"
        maxlength="11"
        inputmode="numeric"
        :disabled="isPerfect==='1'"
        placeholder="请输入"
        type="number"
        v-model.trim="accountForm.mobile"
        @input="(val)=>{
          supplierAccountInfo.contactMobile=val
        }"
        @click="domfocus($event,'mobile')"
      />
      <template v-if="isPerfect!=='1'">
        <van-field
          label="短信验证码"
          ref="smsVerifyCode"
          required
          center
          placeholder="请输入"
          autocomplete="off"
          inputmode="numeric"
          maxlength="6"
          v-model.trim="accountForm.smsVerifyCode"
          @click="domfocus($event,'smsVerifyCode')"
        >
          <template #button>
            <van-button
              style="width:1.7rem;"
              size="small"
              type="info"
              native-type="button"
              :disabled=" timer > 0"
              @click="sendSmsVerifyCode($event)"
            >{{ +timer > 0 ? `${timer}s` : '获取验证码' }}</van-button>
          </template>
        </van-field>
        <van-field
          label="登录密码"
          ref="password"
          required
          center
          type="password"
          autocomplete="new-password"
          placeholder="请设置登录密码"
          v-model.trim="accountForm.password"
          @click="domfocus($event,'password')"
        />
        <van-field
          label="密码确认"
          ref="checkPassword"
          required
          center
          type="password"
          autocomplete="new-password"
          placeholder="请设置登录密码"
          v-model.trim="accountForm.checkPassword"
          @click="domfocus($event,'checkPassword')"
        />
      </template>
      <!--<van-field
        label="主营类目"
        ref="supplierBusinessCategory"
        :disabled="isPerfect==='1'"
        center
        required
        readonly
        autocomplete="off"
        placeholder="请输入"
        v-model.trim="supplierAccountInfo.supplierBusinessCategory"
        @click="showCategoryPicker = true"
      />
      <van-field
        label="属性"
        ref="supplierGradeAttribute"
        :disabled="isPerfect==='1'"
        center
        required
        autocomplete="off"
        readonly
        placeholder="请输入"
        v-model.trim="supplierAccountInfo.supplierGradeAttribute"
        @click="showAttributePicker = true"
      />-->
      <van-field
        label="法人代表"
        autocomplete="off"
        ref="legalPerson"
        :disabled="isPerfect==='1'"
        maxlength="64"
        center
        placeholder="请输入"
        v-model.trim="supplierAccountInfo.legalPerson"
        @click="domfocus($event,'legalPerson')"
      />
      <van-field
        label="统一信用编码"
        :disabled="isPerfect==='1'"
        ref="unifiedCreditCode"
        center
        autocomplete="off"
        placeholder="请输入"
        v-model="supplierAccountInfo.unifiedCreditCode"
        @input="(e) => handleInput(e)"
        @click="domfocus($event,'unifiedCreditCode')"
      />
      <van-field
        label="营业执照地址"
        ref="businessLicenseAddress"
        :disabled="isPerfect==='1'"
        center
        autocomplete="off"
        placeholder="请输入"
        maxlength="200"
        v-model.trim="supplierAccountInfo.businessLicenseAddress"
        @click="domfocus($event,'businessLicenseAddress')"
      />
      <van-field
        label="供应商注册区域"
        ref="region"
        required
        autocomplete="off"
        center
        readonly
        placeholder="请输入"
        v-model.trim="supplierAccountInfo.region"
        @click="showAreaPicker = true"
      />
      <van-field
        label="供应商注册详细地址"
        autocomplete="off"
        ref="address"
        maxlength="200"
        required
        center
        placeholder="请输入"
        v-model.trim="supplierAccountInfo.address"
        @click="domfocus($event,'address')"
      />
      <van-field
        label="供应商负责人"
        ref="contactName"
        required
        center
        autocomplete="off"
        placeholder="请输入"
        maxlength="128"
        v-model.trim="supplierAccountInfo.contactName"
        @click="domfocus($event,'contactName')"
      />
      <van-field
        label="供应商联系电话"
        ref="contactMobile"
        required
        autocomplete="off"
        center
        type="number"
        maxlength="11"
        inputmode="numeric"
        placeholder="请输入"
        :disabled="!canEditContactMobile"
        v-model.trim="supplierAccountInfo.contactMobile"
      />

      <van-cell
        center
        title="营业执照"
        title-style="flex: none;width: 1.8rem;"
      >
        <div class="upload-image">
          <div
            class="item"
            v-for="(item,index) in supplierAccountInfo.businessLicensePhoto"
            :key="item"
          >
            <van-image
              width="1.6rem"
              height="1.6rem"
              :src="item"
            />
            <div
              class="delete-icon"
              @click="deleteUploadImage(index,'businessLicensePhoto')"
            >
              <img src="@/assets/baibu/delete-icon.png" alt="">
            </div>
          </div>
          <van-uploader
            v-model="businessLicensePhoto"
            :max-size="imgMaxSize"
            v-if="supplierAccountInfo.businessLicensePhoto.length<5 && isPerfect !== '1'"
            multiple
            accept="image/png, image/jpeg, image/jpg, image/pdf"
            :before-read="(file)=>{
              return beforeUpload(file)
            }"
            :after-read="(file)=>{
              uploadImage(file,'businessLicensePhoto')
            }"
          />
        </div>
      </van-cell>

      <div class="checkbox">
        <van-checkbox
          v-model="signContextCheck"
          disabled
          shape="square"
        ></van-checkbox>
        <div class="agreement">
          勾选同意
          <span @click="routerJump">
            《百布用户服务协议（供应商）》
          </span>
        </div>
      </div>
      <div
        class="login"
        v-if="isPerfect!=='1'"
        @click="goLogin"
      >
        已有账户，立即登录
      </div>
      <div class="fix-operate">
        <van-button
          round
          block
          type="info"
          native-type="button"
          @click="onSubmit"
        >{{this.isPerfect==='1'?'保存并确认':'立即注册'}}</van-button>
      </div>
      <van-popup v-model="showCategoryPicker" position="bottom">
        <van-picker
          title="选择主营类目"
          show-toolbar
          :columns="supplierBusinessCategoryList"
          @confirm="(value)=>{
            onConfirm(value,'supplierBusinessCategory')
          }"
          @cancel="showCategoryPicker = false"
        />

      </van-popup>
      <van-popup v-model="showAttributePicker" position="bottom">
        <van-picker
          title="选择属性"
          show-toolbar
          :columns="supplierGradeAttributeList"
          @confirm="(value)=>{
            onConfirm(value,'supplierGradeAttribute')
          }"
          @cancel="showAttributePicker = false"
        />
      </van-popup>
      <van-popup v-model="showAreaPicker" position="bottom">
        <van-area
          title="选择区域"
          :area-list="areaList"
          @confirm="(value)=>{
            onConfirm(value,'region')
          }"
          @cancel="showAreaPicker = false"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import {
  getAccountDetail, getSmsVerifyCode, accountRegister,
  accountSave,
} from '@/api/baibu';
import { uploadFile } from '@/api/common';
import { areaList } from '@vant/area-data';

export default {
  name: 'ProviderRegister',
  data() {
    return {
      usingRouteBack: false,
      // 是否完善资料
      isPerfect: '',
      // 显示主营类目
      showCategoryPicker: false,
      // 显示属性
      showAttributePicker: false,
      // 显示省市区
      showAreaPicker: false,
      // 发送短信间隔
      verifyCodeTime: 60,
      // 倒计时
      timer: 0,
      // 图片大小
      imgMaxSize: 10 * 1024 * 1024,
      // 图片上传数量
      imgMaxCount: 5,
      // 省市区
      areaList,
      // 主营类目
      supplierBusinessCategoryList: [
        '针织面料', '梭织面料', '辅料', '其他',
      ],
      // 属性
      supplierGradeAttributeList: [
        '一批商', '其他',
      ],

      // 账户表单
      accountForm: {
        mobile: '', // 注册手机号码
        smsVerifyCode: '', // 短信验证码
        password: '', // 登录密码
        checkPassword: '', // 密码确认
      },

      supplierAccountInfo: {
        supplierName: '', // 供应商名称
        // supplierBusinessCategory: '', // 主营类目
        // supplierGradeAttribute: '', // 属性
        unifiedCreditCode: '', // 统一信用编码
        businessLicenseAddress: '', // 营业执照地址
        legalPerson: '', // 法人代表
        region: '', // 供应商注册区域
        address: '', // 供应商注册详细地址
        contactName: '', // 供应商负责人
        contactMobile: '', // 供应商联系电话
        businessLicensePhoto: [], // 营业执照
      },
      signContextCheck: true,
      // 营业执照
      businessLicensePhoto: [],
      // 类型
      sourceTypeName: 'supplier',
      // 能否修改联系人电话
      canEditContactMobile: true,
      // 联系人code
      supplierCode: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    document.title = '注册';
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'BaibuRegistrationAgreement') {
      next();
      return;
    }
    this.usingRouteBack = false;
    // 账户表单
    this.accountForm = {
      mobile: '', // 注册手机号码
      smsVerifyCode: '', // 短信验证码
      password: '', // 登录密码
      checkPassword: '', // 密码确认
    };

    this.supplierAccountInfo = {
      supplierName: '', // 供应商名称
      // supplierBusinessCategory: '', // 主营类目
      // supplierGradeAttribute: '', // 属性
      unifiedCreditCode: '', // 统一信用编码
      businessLicenseAddress: '', // 营业执照地址
      legalPerson: '', // 法人代表
      region: '', // 供应商注册区域
      address: '', // 供应商注册详细地址
      contactName: '', // 供应商负责人
      contactMobile: '', // 供应商联系电话
      businessLicensePhoto: [], // 营业执照
    };

    next();
  },
  methods: {
    handleInput(e) {
      this.supplierAccountInfo.unifiedCreditCode = e.replace(/[^A-z\d]/g, '');
    },
    // 聚焦
    domfocus(e, ref) {
      e.stopPropagation();
      e.preventDefault();
      if (this.$refs[ref]) {
        this.$refs[ref].focus();
      }
    },
    // 账号表单验证
    accountValidateEvent(name = '') {
      const validate = {
        mobile: [
          { required: true, message: '手机号码不能为空' },
          { pattern: /^1\d{10}$/, message: '手机号码格式不正确' },
        ],
        smsVerifyCode: [
          { required: true, message: '短信验证码不能为空' },
          { pattern: /^\d{6}$/, message: '短信验证码格式不正确' },
        ],
        password: [
          { required: true, message: '请设置登录密码' },
          // { pattern: /^.{6,20}$/, message: '登录密码格式不正确' },
        ],
        checkPassword: [
          { validator: (val) => {
            return this.accountForm.password === val;
          },
          message: '两次输入的密码不一致' },
        ],
      };
      const errorMessage = this.getValidatorMessage(validate, this.accountForm, name) || '';
      return errorMessage;
    },
    formDataValidateEvent(name = '') {
      let validate;

      if (this.isPerfect !== '1') {
        validate = {
          supplierName: [
            { required: true, message: '供应商名称不能为空' },
          ],
          // supplierGradeAttribute: [
          //   { required: true, message: '属性不能为空' },
          // ],
          region: [
            { required: true, message: '供应商注册区域不能为空' },
          ],
          address: [
            { required: true, message: '供应商注册详细地址不能为空' },
          ],
          // supplierBusinessCategory: [
          //   { required: true, message: '请选择主营类目' },
          // ],
          unifiedCreditCode: [
            { validator: (val) => {
              return !val || /^[A-z\d]+$/g.test(val);
            },
            message: '统一信用编码格式不正确' },
          ],
          contactName: [
            { required: true, message: '供应商负责人不能为空' },
          ],
          contactMobile: [
            { required: true, message: '供应商联系电话不能为空' },
            { pattern: /^1\d{10}$/, message: '供应商联系电话格式不正确' },
          ],
        };
      } else {
        validate = {
          region: [
            { required: true, message: '供应商注册区域不能为空' },
          ],
          address: [
            { required: true, message: '供应商注册详细地址不能为空' },
          ],
          contactName: [
            { required: true, message: '供应商负责人不能为空' },
          ],
          contactMobile: [
            { required: true, message: '供应商联系电话不能为空' },
            { pattern: /^1\d{10}$/, message: '供应商联系电话格式不正确' },
          ],
        };
      }
      const errorMessage = this.getValidatorMessage(validate, this.supplierAccountInfo, name);
      return errorMessage;
    },
    // 获取错误信息
    getValidatorMessage(validate, formData, name) {
      let errorMessage;
      const formList = Object.keys(formData);
      if (name) {
        errorMessage = this.validatorEvent(validate[name], formData[name]);
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < formList.length; i++) {
          const formKey = formList[i];
          const rules = validate[formKey];
          errorMessage = this.validatorEvent(rules, formData[formKey]);
          if (errorMessage) {
            break;
          }
        }
      }
      return errorMessage;
    },
    // 表单验证
    validatorEvent(rules = [], value) {
      let errorMessage = '';
      if (Array.isArray(rules) && rules.length) {
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < rules.length; j++) {
          if (rules[j].required && !value) {
            errorMessage = rules[j].message;
            break;
          }
          if (rules[j].pattern && !rules[j].pattern.test(value)) {
            errorMessage = rules[j].message;
            break;
          }
          if (rules[j].validator && !rules[j].validator(value)) {
            errorMessage = rules[j].message;
            break;
          }
        }
      }
      return errorMessage;
    },
    // 浮窗确认
    onConfirm(value, type) {
      if (type === 'region') {
        this.supplierAccountInfo[type] = value
          .filter(item => !!item)
          .map(item => item.name)
          .join('/');
      } else {
        this.supplierAccountInfo[type] = value;
      }
      this.showCategoryPicker = false;
      this.showAttributePicker = false;
      this.showAreaPicker = false;
    },
    // 路由跳转
    routerJump() {
      this.usingRouteBack = true;
      this.$router.push({
        path: `/baibu/registration-agreement/${this.sourceTypeName}`,
        query: { usingRouteBack: 1 },
      });
    },
    // 获取短信验证码时间限制
    setTimer(seconds) {
      this.timer = seconds;
      const interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    // 上传图片
    async uploadImage(files, type) {
      // 上传单文件是对象 多文件是数组
      const form = new FormData();
      if (Array.isArray(files)) {
        const count = this.supplierAccountInfo[type].length || 0;
        const canUploadIndex = this.imgMaxCount - count - 1;
        files.forEach((item, index) => {
          if (index <= canUploadIndex) {
            form.append('files', item.file);
          }
        });
      } else {
        form.append('files', files.file);
      }

      try {
        const { data = [] } = await uploadFile(form);

        const imageList = data.map((img) => {
          return img.url;
        });
        this.supplierAccountInfo[type] = [
          ...this.supplierAccountInfo[type],
          ...imageList,
        ];
      } catch (error) {
        console.error(error);
      }
    },
    // 图片超出大小
    beforeUpload(files) {
      console.log('files', files);
      let flag = true;
      if (Array.isArray(files)) {
        files.forEach((item) => {
          if (item.size >= this.imgMaxSize) {
            console.log('size', item.size);
            flag = false;
          }
        });
      } else if (files.size >= this.imgMaxSize) {
        console.log('size', files.size);

        flag = false;
      }
      if (!flag) {
        this.$toast('单个文件大小不能超过 10M');
      }
      return flag;
    },
    // 删除图片
    deleteUploadImage(index, type) {
      this.supplierAccountInfo[type].splice(index, 1);
    },
    // 发送短信验证码
    async sendSmsVerifyCode(e) {
      e.stopPropagation();
      try {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在提交',
        });

        const message = this.accountValidateEvent('mobile');
        if (message) {
          this.$toast(message);
          return;
        }
        const { successful } = await getSmsVerifyCode(
          { phone: this.accountForm.mobile },
          { 'req-agent': `${this.sourceTypeName}-h5` },
        );
        this.$toast.clear();

        if (successful) {
          this.$toast('验证码发送成功');
          this.setTimer(this.verifyCodeTime);
        }
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    // 提交表单
    async onSubmit() {
      try {
        if (this.isPerfect !== '1') {
          const accountErrorMessage = this.accountValidateEvent();
          if (accountErrorMessage) {
            this.$toast(accountErrorMessage);
            return;
          }
        }

        const formErrorMessage = this.formDataValidateEvent();
        if (formErrorMessage) {
          this.$toast(formErrorMessage);
          return;
        }
        if (!this.signContextCheck) {
          this.$toast('请同意并勾选《注册协议》');
          return;
        }
        const [
          province = '',
          city = '',
          area = '',
        ] = this.supplierAccountInfo.region.split('/');
        // const businessType = this.sourceTypeName.toUpperCase();
        // const isSupplier = businessType === 'SUPPLIER';
        let sendData = {
          businessType: this.isPerfect === '1' ? 'SUPPLIER' : 'TEMPORARY_SUPPLIER',
          signContext: window.localStorage.getItem(`${this.sourceTypeName}AccountInfo_signContext`) || '',
          [this.isPerfect === '1' ? 'supplierAccountInfo' : 'temporarySupplierAccountVo']: {
            ...(this.isPerfect === '1' ? {} : {
              approveSource: '2',
            }),
            ...this.supplierAccountInfo,
            businessLicensePhoto: this.supplierAccountInfo.businessLicensePhoto.join(',') || '',
            province,
            city,
            area,
            supplierCode: this.supplierCode,
          },
        };
        if (!(this.isPerfect === '1')) {
          delete sendData.temporarySupplierAccountVo.region;
        }

        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在提交',
        });
        if (this.isPerfect === '1') {
          await accountSave(sendData, {
            'req-agent': `${this.sourceTypeName}-h5`,
            'current-user-id': Cookies.get(`${this.sourceTypeName}_userId`),
          });
          this.$toast('保存成功');
          setTimeout(() => {
            window.localStorage.removeItem(`${this.sourceTypeName}AccountInfo_signContext`);
            this.$toast.clear();
            this.$router.replace('/baibu/supplier/account');
          }, 1500);
        } else {
          sendData = {
            ...sendData,
            ...this.accountForm,
          };

          await accountRegister(sendData, {
            'req-agent': `${this.sourceTypeName}-h5`,
          });
          this.$toast('注册成功');
          setTimeout(() => {
            window.localStorage.removeItem(`${this.sourceTypeName}AccountInfo_signContext`);
            Object.assign(this.$data, this.$options.data());
            this.$toast.clear();
            this.$router.replace({
              path: '/baibu/supplier/login',
              query: {
                employeeName: sendData.mobile,
                password: sendData.password,
                accountStatus: true,
              },
            });
          }, 1500);
        }
      } catch (error) {
        this.$toast.clear();
        if (error.message === '会话过期，请重新登录') {
          Cookies.remove(`${this.sourceTypeName}_userId`);
          this.$router.replace('/baibu/supplier/login');
        }
        console.log(error);
      }
    },
    goLogin() {
      this.$router.replace('/baibu/supplier/login');
    },
    getAccount() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在获取',
      });
      getAccountDetail(
        {
          businessType: this.sourceTypeName.toUpperCase(),
        }, {
          'req-agent': `${this.sourceTypeName}-h5`,
          'current-user-id': Cookies.get(`${this.sourceTypeName}_userId`),
        },
      ).then((res) => {
        this.$toast.clear();

        const { mobile = '', supplierAccountInfo = {} } = res.data;
        this.accountForm.mobile = mobile;
        Object.keys(this.supplierAccountInfo).forEach((item) => {
          if (item === 'businessLicensePhoto') {
            if (supplierAccountInfo.businessLicensePhoto.length > 0) {
              const imgList = supplierAccountInfo.businessLicensePhoto.split(',');
              this.supplierAccountInfo.businessLicensePhoto = imgList;
              this.businessLicensePhoto = imgList.map((url) => {
                return { url };
              });
            } else {
              this.supplierAccountInfo.businessLicensePhoto = [];
            }
          } else if (item === 'region') {
            if (supplierAccountInfo.province) {
              const {
                province = '',
                city = '',
                area = '',
              } = supplierAccountInfo;
              this.supplierAccountInfo.region = `${province}
              /${city}
              /${area}`;
            } else {
              this.supplierAccountInfo.region = '';
            }
          } else {
            this.supplierAccountInfo[item] = supplierAccountInfo[item];
          }
        });
        this.supplierCode = supplierAccountInfo.supplierCode || '';
        if (/^1\d{10}$/.test(supplierAccountInfo.contactMobile)) {
          this.canEditContactMobile = false;
        }
        console.log(this.supplierAccountInfo);
        this.$forceUpdate();
      }).catch((error) => {
        this.$toast.clear();
        if (error.message === '会话过期，请重新登录') {
          Cookies.remove(`${this.sourceTypeName}_userId`);
          this.$router.replace('/baibu/supplier/login');
        }
      });
    },
  },
  activated() {
    this.$toast.setDefaultOptions({ duration: 1000 });
    if (Cookies.get(`${this.sourceTypeName}_userId`)) {
      // 存在登录信息并且是完善标识并且有协议才是完善信息
      if (`${this.$route?.query?.isPerfect}` === '1'
        && window.localStorage.getItem(`${this.sourceTypeName}AccountInfo_signContext`)) {
        this.isPerfect = '1';
        if (this.usingRouteBack) {
          return;
        }
        this.getAccount();
      } else {
        this.$router.replace({
          path: '/baibu/supplier/account',
        });
      }
    } else if (!window.localStorage.getItem(`${this.sourceTypeName}AccountInfo_signContext`)) {
      this.$router.replace({
        path: '/baibu/supplier/login',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.register {
  .top-title {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.32rem;
    font-weight: bold;
    text-align: center;
    border-bottom: 0.01rem solid rgb(228, 226, 226);
    background: #fff;
    z-index: 2;
    .goback-btn {
      position: absolute;
      left: 0.3rem;
      top: 50%;
      font-size: 0.2rem;
      transform: translateY(-50%);
      color: cornflowerblue;
    }
  }
  .content {
    padding: .2rem 0 2rem 0;
    .agreement {
      margin-left: 0.2rem;
      font-size: 0.32rem;
      span {
        color: #1989fa;
      }
    }
    ::v-deep {
      .van-cell:not(:last-child)::after{
        left: 0;
      }
      .van-field__control {
        line-height: 0.48rem;
      }
    }
    .checkbox {
      display: flex;
      align-items: center;
      padding: 0.2rem 0.3rem;
      ::v-deep {
        .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{
          color: #fff;
        }
        .van-checkbox__icon--disabled .van-icon{
          background-color: #1989fa;
          border-color: #1989fa;
        }
      }
    }
    .upload-image {
      display: flex;
      flex-wrap: wrap;
      .item {
        position: relative;
        width: 1.6rem;
        height: 1.6rem;
        margin: 0 0.2rem 0.2rem 0;
        .delete-icon {
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 0.32rem;
          height: 0.32rem;
          background: rgba(0,0,0,0.3);
          img{
            width: 0.26rem;
            height: 0.26rem;
          }
        }
      }
    }
    ::v-deep {
      .van-uploader__preview {
        display: none;
      }
    }
    .login {
      margin-top: 0.5rem;
      text-align: center;
      font-size: 0.28rem;
      color: #1989fa;
    }
  }
  .fix-operate {
    display: flex;
    align-items: center;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1.5rem;
    padding: 0 0.3rem;
    background: #fff;
  }
}
</style>
